import Modal from '@/components/Modals/Modal/Modal'

import styles from './DocumentsListModal.module.scss'

function DocumentsListModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.modalInner}>
        <div className={styles.content}>
          <h3 className={styles.title}>Список документов для получения стартового пакета</h3>
          <p className={styles.text}>
            Допуск участника к мероприятию и получение участником стартового пакета возможен через доверенное лицо и
            осуществляется при предоставлении доверенным лицом участника Организаторам Мероприятия следующих документов:
          </p>
          <ul className={styles.documentsList}>
            <li className={styles.documentsItem}>копии удостоверения личности участника забега;</li>
            <li className={styles.documentsItem}>удостоверения личности доверенного лица;</li>
            <li className={styles.documentsItem}>
              оригинала одного из двух вариантов медицинской справки с печатью выдавшего учреждения, с подписью и личной
              печатью врача, в которой должно быть указано: см. выше.;
            </li>
            <li className={styles.documentsItem}>
              оригинала доверенности на имя доверенного лица, написанного рукописным текстом;
            </li>
            <li className={styles.documentsItem}>согласие на обработку персональных данных</li>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default DocumentsListModal
